import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

export const Hero = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative dot-grid border-b-4 border-gray-900 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 bg-white border-[3px] border-gray-900 rounded-full px-4 py-1.5 nb-shadow-sm mb-6"
          >
            <Sparkles size={16} className="text-[#FF477E]" />
            <span className="text-xs font-bold uppercase tracking-[0.2em]">
              SaaS · AI · Mobile · Web
            </span>
          </div>

          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl leading-[0.95]">
            Software that <span className="bg-[#FBD46D] px-2 border-[3px] border-gray-900 nb-shadow-sm inline-block -rotate-1">actually</span> delivers.
          </h1>

          <p className="mt-6 text-lg md:text-xl font-medium text-gray-700 max-w-xl">
            Paragon IT Services builds production-grade <span className="font-bold text-gray-900">SaaS platforms</span>,
            <span className="font-bold text-gray-900"> AI/ML solutions</span>, and
            <span className="font-bold text-gray-900"> mobile apps</span> for startups and enterprises — fast, focused, and beautifully engineered.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => go("contact")}
              className="bg-[#FF477E] text-white border-[4px] border-gray-900 font-bold text-lg px-7 py-4 rounded-xl nb-shadow-sm nb-hover inline-flex items-center gap-2"
            >
              Start a project <ArrowRight size={20} />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => go("services")}
              className="bg-white text-gray-900 border-[4px] border-gray-900 font-bold text-lg px-7 py-4 rounded-xl nb-shadow-sm nb-hover"
            >
              See our work
            </button>
          </div>

          <div className="mt-10 flex flex-wrap gap-6 text-sm font-bold">
            <div data-testid="hero-stat-1" className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-[#6BCB77] border-2 border-gray-900" />
              50+ products shipped
            </div>
            <div data-testid="hero-stat-2" className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-[#4D96FF] border-2 border-gray-900" />
              AI-first engineering
            </div>
            <div data-testid="hero-stat-3" className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-[#FBD46D] border-2 border-gray-900" />
              India · Global clients
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9, rotate: 3 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
          className="relative"
        >
          <div className="absolute -top-6 -left-6 w-24 h-24 bg-[#4D96FF] border-[4px] border-gray-900 rounded-2xl nb-shadow rotate-6 hidden sm:block" />
          <div className="absolute -bottom-6 -right-6 w-28 h-28 bg-[#6BCB77] border-[4px] border-gray-900 rounded-full nb-shadow hidden sm:block" />
          <div className="relative bg-white border-[4px] border-gray-900 rounded-3xl nb-shadow-lg p-6 md:p-8">
            <img
              data-testid="hero-image"
              src="https://static.prod-images.emergentagent.com/jobs/a8216672-e1e1-44b7-a0bd-e8478222755e/images/f79e68111c67c7798dcf7a2731f0e3b61e7c4546d8111c96e30254d518ba16a9.png"
              alt="Playful 3D AI brain floating above a smartphone"
              className="w-full h-auto rounded-2xl"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
